import { render } from "./ThePage.vue?vue&type=template&id=c7c07e1c&scoped=true"
import script from "./ThePage.vue?vue&type=script&lang=js"
export * from "./ThePage.vue?vue&type=script&lang=js"

import "./ThePage.vue?vue&type=style&index=0&id=c7c07e1c&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7c07e1c"]])

export default __exports__